module.exports = __webpack_public_path__ + "static/media/image-diamond.c0cf9eda.jpg";